import { firstName } from "./../../../validations/yupValidations";
import { ICreateAndUpdateClient } from "../../../types/client.interface";
import customAxios from "../../customAxios";
import { UPDATE_CLIENT } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const updateClient = async (props: ICreateAndUpdateClient) => {
  const body = {
    firstName: props?.firstName,
    lastName: props?.lastName,
    phoneNumber: props?.phoneNumber,
  };

  try {
    return (await customAxios.put(UPDATE_CLIENT + `/${props._id}`, body)).data;
  } catch (error: unknown) {
    console.error({ UPDATE_CLIENT: error });
    return false;
  }
};

export default updateClient;
